import { render } from "./ShopDashboard.vue?vue&type=template&id=26965539&scoped=true"
import script from "./ShopDashboard.vue?vue&type=script&lang=js"
export * from "./ShopDashboard.vue?vue&type=script&lang=js"

import "./ShopDashboard.vue?vue&type=style&index=0&id=26965539&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26965539"]])

export default __exports__